import { resolveStoredTheme } from "@fomofi/shared";

/**
 * Theme option B (BEN-141; Paul 2026-10-08, report -95). Run once per launch, before the
 * first render, so next-themes reads a Light or Dark choice and the first frame is right.
 * Idempotent: after one run the stored value is always "light" or "dark", which it keeps.
 * A browser that blocks storage keeps next-themes' default (light).
 */
export function migrateStoredTheme(
  storage: Pick<Storage, "getItem" | "setItem">,
  key: string,
  deviceIsDark: boolean,
): void {
  try {
    const stored = storage.getItem(key);
    const next = resolveStoredTheme(stored, deviceIsDark);
    if (stored !== next) storage.setItem(key, next);
  } catch {
    // Storage unavailable (private mode, blocked site data): nothing to migrate.
  }
}
